import { Link } from "react-router-dom";
import { videos, categories } from "@/mocks/videoData";

export default function HotSection() {
  const hotVideos = videos.filter((v) => v.rating >= 9.0).slice(0, 6);

  const getCategoryName = (slug: string) => {
    const cat = categories.find((c) => c.slug === slug);
    return cat ? cat.name : slug;
  };

  return (
    <section className="px-4 md:px-6 py-14 md:py-20">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading">
              热门推荐
            </h2>
            <p className="text-sm text-foreground-600 mt-1">精选高分佳作，每一部都值得观看</p>
          </div>
          <Link
            to="/category/movie"
            className="text-sm text-primary-500 hover:text-primary-600 font-medium whitespace-nowrap flex items-center gap-1"
          >
            查看更多 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3 md:gap-4" data-product-shop="">
          {hotVideos.map((video) => (
            <Link
              key={video.id}
              to={`/article/${video.id}`}
              className="group cursor-pointer"
            >
              <div className="relative overflow-hidden rounded-lg aspect-video mb-3">
                <img
                  src={video.thumbnail}
                  alt={video.title}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                  title={`${video.title} - 苹果视频免费在线观看`}
                  loading="lazy"
                />
                <div className="absolute top-2 right-2 bg-foreground-950/80 text-background-50 text-xs font-bold px-2 py-0.5 rounded">
                  {video.rating}
                </div>
                <div className="absolute inset-0 bg-foreground-950/0 group-hover:bg-foreground-950/20 transition-colors flex items-center justify-center">
                  <span className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-500/90 text-background-50 opacity-0 group-hover:opacity-100 transition-opacity">
                    <i className="ri-play-fill text-lg"></i>
                  </span>
                </div>
              </div>
              <h3 className="text-sm font-medium text-foreground-950 group-hover:text-primary-500 transition-colors line-clamp-1">
                {video.title}
              </h3>
              <p className="text-xs text-foreground-500 mt-0.5">
                {getCategoryName(video.category)} · {video.year}
              </p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}